'use strict';

const init = () => {
    if (document.body.classList.contains('tc-website-project')) {
        document.querySelector('.back-to-list a').addEventListener('click', () => {
            if (sessionStorage.getItem('selectedFilters') || sessionStorage.getItem('tc-projects-scroll')) {
                sessionStorage.setItem('keepData', 'true')
            }
        })
    }
}

export default {init}
